import { createFileRoute } from "@tanstack/react-router";

import { CreateDemoForm } from "@/founder/demo/CreateDemoForm";

export const Route = createFileRoute("/founder/demo/create")({
    component: RouteComponent,
});

function RouteComponent() {
    return <CreateDemoForm />;
}
